import {login } from './http'
import {GET } from './http'
import { POST } from './http'
import { getData } from './http'

//获取用户信息
export const getinfo = p => GET('admin/user/info', p);
export const addLecturer = p => POST('/portal/lecturerUs', p);

export const loginUser = p => login('/auth/oauth/token', p);

// 企业资讯
export const newsList = () => GET('portal/gov/showNewList');
export const newsDetail = p => GET('auth/oauth/token'+p);

// 企业资讯
export const getNewsList = p => getData('portal/gov/showNewList', p);
// 企业详情
export const newsDetails = p => getData('portal/gov/showNewDetail/' + p);


// 设备信息
export const getDeviceInfo = p => GET(`portal/suyuan/getDeviceInfo/${p}`);


// 获取设备编号
export const getDeviceInfoIdToCode = p => GET(`portal/suyuan/getDeviceInfoIdToCode/${p}`);
// 获取未绑定设备溯源码的企业列表
export const getOrganizationList = p => POST('portal/suyuan/getOrganizationList', p);
// 根据上面接口返回的 企业id 获取 该企业 未绑定设备溯源码的项目设备
export const getDeviceCode = p => GET(`portal/suyuan/getDeviceCodeNull/${p}`);
// 关联设备  和溯源码 { "id":1, "deviceCode": "溯源码" }
export const joinDevice = p => POST('portal/suyuan/saveCode', p);

// 生成吗
export const createCode = p => GET('business/zymgen/page', p);

export const saveComplaininfo = p => POST('portal/gov/saveComplaininfo', p);

export const suyuanDrewCount = p => getData('portal/suyuan/suyuanDrew/count', p);

export const suyuanDrewUserPrizeInfo = p => getData('portal/suyuan/suyuanDrew/user/prize/info', p);

export const suyuanDrewPrizeInfo = p => GET('portal/suyuan/suyuanDrew/prize/info');

export const suyuanDrewSendCode = p => POST('portal/suyuan/suyuanDrew/sendCode', p);

export const suyuanDrewCheckPhoneCode = p => POST('portal/suyuan/suyuanDrew/checkPhoneCode', p);



// WEBPACK FOOTER //
// ./src/api/api.js